import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, filter, map, Observable } from 'rxjs';
import { Articoli, ArticoliReqModel } from 'src/app/models/articoli';
import { environment } from '../../../environments/environment';
import { PrintBarCodeModel } from 'src/app/models/print-barcode-model';
import { ArticoliConsegnaModel } from 'src/app/models/articoli-consegna-model';
import notify from 'devextreme/ui/notify';
@Injectable({
  providedIn: 'root',
})
export class ArticoliService {
  private http = inject(HttpClient);

  articoliUrl = environment.ildatoArticoliDpi + 'api/articoli';

  private _listArticoli = new BehaviorSubject<Articoli[] | undefined>(undefined);

  list(soloAttivi = true): Observable<Articoli[]> {
    return this.http.get<Articoli[]>(
      this.articoliUrl + '?SoloAttivi=' + soloAttivi,
    );
  }

   listTemp(
    forceRefresh: boolean = false,
  ): Observable<Articoli[]> {
    if (
      this._listArticoli.value == undefined ||
      forceRefresh
    ) {
      this.http
        .get<Articoli[]>(this.articoliUrl + '?SoloAttivi=false') //Prelevo tutti gli articoli
        .subscribe({
          next: (res) => {
            this._listArticoli.next(res);
          },
          error: (err) => {
            if (err?.error?.title) {
              notify(err.error.title, 'error');
            } else {
              notify('Errore recupero lista articoli', 'error');
            }
          },
        });
    }

    return this._listArticoli.asObservable().pipe(filter((r) => r != null));
  }

  consegnePrevisteGiornaliere(
    model: ArticoliReqModel,
  ): Observable<ArticoliConsegnaModel[]> {
    return this.http.post<Articoli[]>(
      this.articoliUrl + '/consegneprevistegiornaliere',
      model,
    );
  }

  listNonKit(): Observable<Articoli[]> {
    return this.http.get<Articoli[]>(this.articoliUrl + '/listnonkit');
  }

  listByTipo(idTipo: number, soloAttivi = true): Observable<Articoli[]> {
    return this.http.get<Articoli[]>(
      this.articoliUrl + '/bytipo/' + idTipo + '?SoloAttivi=' + soloAttivi,
    );
  }

  listConMatricole(): Observable<Articoli[]> {
    return this.http.get<Articoli[]>(
      this.articoliUrl + '/articoliconmatricole',
    );
  }

  get(id: number): Observable<Articoli> {
    return this.http.get<Articoli>(this.articoliUrl + '/' + id);
  }

  insert(values: Articoli): Observable<Articoli> {
    console.log(values);
    return this.http.post<Articoli>(this.articoliUrl, values);
  }

  remove(idDpi: number): Observable<Articoli> {
    console.log(idDpi);
    return this.http.delete<Articoli>(this.articoliUrl + '/' + idDpi);
  }

  update(key: number, values: Articoli): Observable<Articoli> {
    console.log(values);
    return this.http.put<Articoli>(this.articoliUrl + '/' + key, values);
  }

  disattivaArticolo(
    idArticolo: number,
    idArticoloSostitutivo: number,
  ): Observable<Articoli> {
    let paramArtSost = '';
    if (idArticoloSostitutivo != null && idArticoloSostitutivo != 0) {
      paramArtSost = '?IdSostitutivo=' + idArticoloSostitutivo;
    }

    return this.http.put<Articoli>(
      this.articoliUrl + '/disattiva/' + idArticolo + paramArtSost,
      true,
    );
  }

  sostituisciArticolo(
    idArticolo: number,
    idArticoloSostitutivo: number,
  ): Observable<Articoli> {
    return this.http.put<Articoli>(
      this.articoliUrl +
        '/sostituisci/' +
        idArticolo +
        '/' +
        idArticoloSostitutivo,
      true,
    );
  }

  stampaEtichette(barCodeModel: PrintBarCodeModel): Observable<Blob> {
    return this.http.post(this.articoliUrl + '/stampeEtichette', barCodeModel, {
      responseType: 'blob',
    });
  }

  cleanTemp(){
    this._listArticoli.next(undefined);
  }
}
